import { render, staticRenderFns } from "./ProofFormSetting.vue?vue&type=template&id=0aad5097"
import script from "./ProofFormSetting.vue?vue&type=script&lang=js"
export * from "./ProofFormSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports